import React from 'react'
import Headline from 'gatsby-theme-kn/src/components/atoms/Headline'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'

import SpaceWhy from 'gatsby-theme-kn/src/assets/images/space-why.svg'
import SpaceHowto from 'gatsby-theme-kn/src/assets/images/space-howto.svg'

import SpaceKnowhow from 'gatsby-theme-kn/src/assets/images/space-knowhow.svg'
import SpaceTippstools from 'gatsby-theme-kn/src/assets/images/space-tippstools.svg'

import DoubleMarker from 'gatsby-theme-kn/src/assets/images/double-marker-line.svg'
import ExclamationMark from 'gatsby-theme-kn/src/assets/images/exclamation-mark.svg'
import SbEditable from 'storyblok-react'

const HeaderBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      {(block.kicker?.length > 0 ||
        block.headline?.length > 0 ||
        block.subheadline?.length > 0) && (
        <section
          className={`header-block ${className} ${
            block.space_top ? block.space_top : ''
          } ${block.space_bottom ? block.space_bottom : ''}`}
        >
          <div className="header-block-content">
            {block.style && block.style === 'marker' ? (
              <div className="header-block-marker">
                <Headline
                  kicker={block.kicker}
                  headline={block.headline}
                  subheadline={block.subheadline}
                  headline_level={block.headline_level}
                />
              </div>
            ) : block.style &&
              (block.style === 'spacewhy' ||
                block.style === 'spacehowto' ||
                block.style === 'spaceknowhow' ||
                block.style === 'spacetippstools' ||
                block.style === 'exclamationmark') ? (
              <div
                className={`header-block-space ${
                  block.style === 'exclamationmark'
                    ? 'header-block-exclamation'
                    : ''
                }`}
              >
                <div>
                  <Image
                    image={
                      block.style === 'spacewhy'
                        ? SpaceWhy
                        : block.style === 'spacehowto'
                        ? SpaceHowto
                        : block.style === 'spaceknowhow'
                        ? SpaceKnowhow
                        : block.style === 'spacetippstools'
                        ? SpaceTippstools
                        : ExclamationMark
                    }
                  />
                </div>
                <div>
                  <Headline
                    kicker={block.kicker}
                    headline={block.headline}
                    subheadline={block.subheadline}
                    headline_level={block.headline_level}
                  />
                </div>
              </div>
            ) : (
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
                headline_level={block.headline_level}
              />
            )}
          </div>
        </section>
      )}
    </SbEditable>
  )
}

export default HeaderBlock
